var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLevels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H7.425V11.675H10V8.35H12.575V5H14C14.2833 5 14.5207 4.90433 14.712 4.713C14.904 4.521 15 4.28333 15 4C15 3.71667 14.904 3.479 14.712 3.287C14.5207 3.09567 14.2833 3 14 3H10.575V6.325H8V9.65H5.425V13H4C3.71667 13 3.479 13.096 3.287 13.288C3.09567 13.4793 3 13.7167 3 14C3 14.2833 3.09567 14.5207 3.287 14.712C3.479 14.904 3.71667 15 4 15ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H2ZM2 16H16V2H2V16Z",
    fill: "#101828"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default "data:image/svg+xml,%3csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M4 15H7.425V11.675H10V8.35H12.575V5H14C14.2833 5 14.5207 4.90433 14.712 4.713C14.904 4.521 15 4.28333 15 4C15 3.71667 14.904 3.479 14.712 3.287C14.5207 3.09567 14.2833 3 14 3H10.575V6.325H8V9.65H5.425V13H4C3.71667 13 3.479 13.096 3.287 13.288C3.09567 13.4793 3 13.7167 3 14C3 14.2833 3.09567 14.5207 3.287 14.712C3.479 14.904 3.71667 15 4 15ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H2ZM2 16H16V2H2V16Z' fill='%23101828'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };